import { useMemo } from "react";
var makeColor = function (_a) {
    var _b = _a.defaultColor, defaultColor = _b === void 0 ? "inputBorder" : _b, _c = _a.success, success = _c === void 0 ? "success" : _c, _d = _a.error, error = _d === void 0 ? "error" : _d, _e = _a.disabled, disabled = _e === void 0 ? "inputBorder" : _e;
    return ({
        success: success,
        error: error,
        disabled: disabled,
        default: defaultColor,
    });
};
var useCheckboxStyles = function (_a) {
    var disabled = _a.disabled, success = _a.success, error = _a.error, focused = _a.focused;
    var status = success ? "success" : error ? "error" : disabled ? "disabled" : "default";
    var styledCheckbox = useMemo(function () {
        return {
            width: "20px",
            height: "20px",
            background: disabled ? "mainBackgroundDisabled" : "mainBackground",
            justifyContent: "center",
            alignItems: "center",
            border: {
                size: "1px",
                type: "solid",
                color: focused
                    ? makeColor({ defaultColor: "inputBorderFocus" })[status]
                    : makeColor({})[status],
                side: "all",
            },
            round: true,
            _focus: {
                border: {
                    size: "1px",
                    type: "solid",
                    color: makeColor({ defaultColor: "controlFocused" })[status],
                    side: "all",
                },
                boxShadow: {
                    color: makeColor({ defaultColor: "controlFocused" })[status],
                    size: "0 0 0 1px",
                },
            },
        };
    }, [status, focused]);
    return { styles: { styledCheckbox: styledCheckbox } };
};
export default useCheckboxStyles;
